var React = require('react');

function Indentification (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.25 10.5H18M14.25 13.5H18M8.633 13.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M5.729 15.75a3 3 0 0 1 5.81 0","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M20.25 4.5H3.75a.75.75 0 0 0-.75.75v13.5c0 .414.336.75.75.75h16.5a.75.75 0 0 0 .75-.75V5.25a.75.75 0 0 0-.75-.75Z","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Indentification.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","strokeWidth":"2.002"};

module.exports = Indentification;

Indentification.default = Indentification;
